import React from 'react';

function LatestStats() {
  return (
    <div className="card">
      <h3>Latest Rates & Stats</h3>
      <ul>
        <li>Savings Account: 0.75% APY</li>
        <li>1-Year GIC: 3.00% APY</li>
        <li>5-Year Term Loan: 15%</li>
        <li>5-Year Commercial REIT Loans: 6.5%</li>
        <li>5-Year Startup Loans: 9.75%</li>
      </ul>
    </div>
  );
}

export default LatestStats;
